const businessesTypes = {

  get: {
    request: "GET_BUSINESS_REQUEST",
    success: "GET_BUSINESS_SUCCESS",
    failure: "GET_BUSINESS_FAILURE"
  },

  index: {
    request: "BUSINESSES_INDEX_REQUEST",
    success: "BUSINESSES_INDEX_SUCCESS",
    failure: "BUSINESSES_INDEX_FAILURE",
    select:  "BUSINESSES_INDEX_SELECT"
  },

  create: {
    init:    "CREATE_BUSINESS_INIT",
    request: "CREATE_BUSINESS_REQUEST",
    success: "CREATE_BUSINESS_SUCCESS",
    failure: "CREATE_BUSINESS_FAILURE"
  },

  update: {
    request: "UPDATE_BUSINESS_REQUEST",
    success: "UPDATE_BUSINESS_SUCCESS",
    failure: "UPDATE_BUSINESS_FAILURE"
  },

  activate: {
    request: "BUSINESS_OPERATION_REQUEST",
    success: "BUSINESS_OPERATION_SUCCESS",
    single: "BUSINESS_OPERATION_SINGLE_SUCCESS",
    failure: "BUSINESS_OPERATION_FAILURE"
  },
  //
  // deactivate: {
  //   request: "BUSINESS_OPERATION_REQUEST",
  //   success: "BUSINESS_OPERATION_SUCCESS",
  //   single: "BUSINESS_OPERATION_SINGLE_SUCCESS",
  //   failure: "BUSINESS_OPERATION_FAILURE"
  // },


  set_errors: "SET_BUSINESS_ERRORS",

  reset_business: "RESET_BUSINESS",

  clear_business: "CLEAR_BUSINESS",

}

export default businessesTypes



// WEBPACK FOOTER //
// ./src/js/constants/businessesTypes.js